// extracted by mini-css-extract-plugin
module.exports = {"heading":"generic-teaser_heading__yn91M"};